import React, { useEffect, useState } from 'react';
import {
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';

import Layout from '@/admin/view/layout/Layout';
import authorizeAction from '@/admin/actions/authorize.action';
import Projects from '@/admin/view/pages/projects';
import Users from '@/admin/view/pages/users';
import Dashboards from '@/admin/view/pages/dashboards';
import t from '@/utils/translate';

export default function () {
  const [authorized, setAuthorized ] = useState<boolean | null>(null);

  useEffect(() => {
    authorizeAction().then((a) => setAuthorized(a));
  }, []);

  if (authorized === null) {
    return <>{t('admin.hint.authorization')}</>;
  }

  if (!authorized) {
    return <Navigate to="/" replace/>;
  }

  return (
    <Layout>
      <Routes>
          <Route path="/dashboards/*" element={<Dashboards/>}/>
          <Route path="/projects/*" element={<Projects/>}/>
          <Route path="/users/*" element={<Users/>}/>
          <Route path="/claims/*" element={t('admin.title.claims')}/>
          <Route path="/*" element={<Navigate to="./projects" replace />}/>
      </Routes>
    </Layout>
  );
};